/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-left:auto;margin-right:auto}@media (min-width:992px){.header[_ngcontent-%COMP%]{margin-left:0;margin-right:0}}.level-tag[_ngcontent-%COMP%]{background-color:#e5f1ff;color:#444;font-size:.75rem;line-height:.75rem;border-radius:2px;padding:.25rem .5rem}.track-name[_ngcontent-%COMP%]{font-size:1.3rem;font-weight:bolder}"];
export { styles as styles };
//# sourceMappingURL=private-class-header.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-left-header-banner/private-class-header/private-class-header.component.scss.shim.ngstyle.js
// module id = 1414
// module chunks = 26 27 28